// Format an ISO/Date-parseable value as a short relative-time string, e.g.
// "just now", "5m ago", "3h ago", "2d ago". Falls back to a locale date
// string beyond a week out.
//
// NOTE: prefer formatSecondsAgo() over this when the API provides a
// `*_seconds_ago` field — parsing an ISO timestamp client-side is subject to
// timezone-parsing drift (e.g. a naive "YYYY-MM-DDTHH:mm:ss" string with no
// "Z"/offset gets interpreted as local time instead of UTC), which throws
// the computed delta off by the viewer's UTC offset. A server-computed
// seconds-ago value has no such ambiguity.
export function formatRelativeTime(dateInput) {
  if (!dateInput) return ''
  const date = new Date(dateInput)
  if (isNaN(date.getTime())) return ''

  const diffSec = Math.round((Date.now() - date.getTime()) / 1000)
  return formatSecondsAgo(diffSec)
}

// Format a raw "seconds elapsed" number (e.g. the API's
// `created_at_seconds_ago`) as a short relative-time string: "just now",
// "5s ago", "5m ago", "3h ago", "2d ago", "3mo ago", "1y ago".
export function formatSecondsAgo(seconds) {
  const diffSec = Math.round(Number(seconds))
  if (!Number.isFinite(diffSec)) return ''
  if (diffSec < 5) return 'just now'
  if (diffSec < 60) return `${diffSec}s ago`

  const diffMin = Math.round(diffSec / 60)
  if (diffMin < 60) return `${diffMin}m ago`

  const diffHr = Math.round(diffMin / 60)
  if (diffHr < 24) return `${diffHr}h ago`

  const diffDay = Math.round(diffHr / 24)
  if (diffDay < 30) return `${diffDay}d ago`

  const diffMonth = Math.round(diffDay / 30)
  if (diffMonth < 12) return `${diffMonth}mo ago`

  const diffYear = Math.round(diffMonth / 12)
  return `${diffYear}y ago`
}
